import { OVERLAY_ACTIVE_CLASS } from '../constants';
import { ScrollTopCache } from '../util';

function getFocusableElements($container) {
  return $container
    .find(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
    .filter(':visible')
    .filter(function () {
      return (
        $(this).attr('tabindex') !== '-1' &&
        $(this).closest('[inert]').length === 0
      );
    });
}

export const initialize = function () {
  let $offcanvasNavigation = $('.OffCanvasNavigation');
  if (!$offcanvasNavigation.length) {
    return;
  }

  let scrollTopCache = new ScrollTopCache();
  let $lastToggleTrigger = null;

  // Level-2 lists start hidden and inert so keyboard focus can't reach them
  // until they slide in.
  $offcanvasNavigation.find('ul.Navigation__List--level2').attr('inert', '');

  function resetToLevel1() {
    $offcanvasNavigation
      .find('ul.Navigation__List--level2.active')
      .removeClass('active')
      .attr('inert', '');
    $offcanvasNavigation
      .find('a.down[aria-expanded="true"]')
      .attr('aria-expanded', 'false');
  }

  function openOffCanvas() {
    scrollTopCache.update();
    resetToLevel1();
    $('html').addClass(OVERLAY_ACTIVE_CLASS);
    $offcanvasNavigation.addClass(OVERLAY_ACTIVE_CLASS);
    $offcanvasNavigation.attr('aria-hidden', 'false');
    $('.OffCanvasToggle').attr('aria-expanded', 'true');
    $offcanvasNavigation
      .find('.OffCanvasNavigation__CloseButton')
      .first()
      .focus();
  }

  function closeOffCanvas() {
    $('html').removeClass(OVERLAY_ACTIVE_CLASS);
    $offcanvasNavigation.removeClass(OVERLAY_ACTIVE_CLASS);
    $offcanvasNavigation.attr('aria-hidden', 'true');
    $('.OffCanvasToggle').attr('aria-expanded', 'false');
    $('.MainNavigation__Item--Quick').removeClass('active');
    scrollTopCache.apply();
    if ($lastToggleTrigger) {
      $lastToggleTrigger.focus();
      $lastToggleTrigger = null;
    }
  }

  $('.Header__OffCanvasToggle').on('click', function (e) {
    e.preventDefault();
    $lastToggleTrigger = $(this).find('.OffCanvasToggle');
    if ($offcanvasNavigation.hasClass(OVERLAY_ACTIVE_CLASS)) {
      closeOffCanvas();
    } else {
      openOffCanvas();
    }
  });

  $offcanvasNavigation.on(
    'click',
    '.OffCanvasNavigation__CloseButton',
    function (e) {
      e.preventDefault();
      closeOffCanvas();
    }
  );

  // Slide level 2 in when a .down link is clicked; the target ul is the anchor's
  // sibling inside the same <li>. Only level 2 exists — nested .down handlers do
  // not exist because {item.children.*.children} is not rendered.
  $offcanvasNavigation.on('click', 'a.down', function (e) {
    e.preventDefault();
    const $targetUl = $(this).siblings('ul.Navigation__List--level2');
    if (!$targetUl.length) return;
    $(this).attr('aria-expanded', 'true');
    $targetUl.addClass('active').removeAttr('inert');
    $targetUl.find('> li:not(.back) a').first().focus();
  });

  // Slide level 2 out when its .back item is clicked. Return focus to the .down
  // link that opened it.
  $offcanvasNavigation.on('click', 'a.back', function (e) {
    e.preventDefault();
    const $activeUl = $(this).closest('ul.Navigation__List--level2');
    const $downLink = $activeUl.siblings('a.down');
    $activeUl.removeClass('active').attr('inert', '');
    $downLink.attr('aria-expanded', 'false').focus();
  });

  $(document).on('keydown', function (e) {
    if (!$offcanvasNavigation.hasClass(OVERLAY_ACTIVE_CLASS)) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeOffCanvas();
      return;
    }

    if (e.key !== 'Tab') return;

    const $focusable = getFocusableElements($offcanvasNavigation);
    if (!$focusable.length) return;

    const first = $focusable[0];
    const last = $focusable[$focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
};

$('.Navigation__List--OffCanvas').on('scroll', function () {
  $('.MainNavigation__Item--Language').removeClass('active');
});
